import { render, staticRenderFns } from "./TheoDoiDialog.vue?vue&type=template&id=160e845b&scoped=true"
import script from "./TheoDoiDialog.vue?vue&type=script&lang=js"
export * from "./TheoDoiDialog.vue?vue&type=script&lang=js"
import style0 from "./TheoDoiDialog.vue?vue&type=style&index=0&id=160e845b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e845b",
  null
  
)

export default component.exports